import lib from "./../js-lib/lib.js";
import { _$ } from "./../js-lib/jsr.js";


const uniqueID = () => {
  return Math.floor(Math.random() * Date.now())
  }

const frm_section2 = {
  scope: () => {},
  render: () => {
    const gform = lib.qs(".gform_wrapper");


    if (!gform) {
      return;
    }

    let data = [];

    if(document.getElementById("choice_13_26_0")) {
      document.getElementById("choice_13_26_0").checked = true; // Auto Check: Has your school attended an IRIS Conference before?
    }

    // Parent People Container
    let people = _$.create(
      `<div id="project_group"></div>`,
      "#frm_section2",
      4
    );

    // Add Person Button
    let createGroup = _$.create(
      `<button class="frm--input">Add Group</button>`,
      lib.id('frm_section2'),
      5
    );

    let collect = "";

    const getRandomInt = (max) => {
      return Math.floor(Math.random() * max);
    };

    const dataCollection = () => {
      collect = "";

      lib.qsa(".pi_group").forEach((a, z) => {
        // Individual Project // NESTED FIELD
        a.querySelectorAll(".studentContainer").forEach((b, x) => {
          // Individual Student

          // Check if Array Created
          if (!window.state.datapiGroupList[z]) {
            window.state.datapiGroupList[z] = [];
          }

          if (!window.state.datapiGroupList[z][3]) {
            window.state.datapiGroupList[z][3] = [];
          }

          // Check if Array Created
          if (!window.state.datapiGroupList[z][3][x]) {
            window.state.datapiGroupList[z][3][x] = [];
          }

          b.querySelectorAll(".subPiField").forEach((c, y) => {
            // Individual Field

            // Check if Array Created
            if (!window.state.datapiGroupList[z][3][x][y]) {
              window.state.datapiGroupList[z][3][x][y] = [];
            }

            if (c.tagName !== "UL") {
              window.state.datapiGroupList[z][3][x][y] = c.value;
            }

            // Add Value to Array
            if (c.tagName === "UL") {
              let getValue = c.querySelector("input[type=radio]:checked");

              if (getValue) {
                window.state.datapiGroupList[z][3][x][y] =
                  getValue.dataset.value;
              }
            }
          });
        });

        // SINGLE FIELD
        a.querySelectorAll(".dataPiField").forEach((b, x) => {
          // Check if Array Created
          if (!window.state.datapiGroupList[z]) {
            window.state.datapiGroupList[z] = [];
          }

          // Check if Array Created
          if (!window.state.datapiGroupList[z][x]) {
            window.state.datapiGroupList[z][x] = [];
          }

          // Data Example:
          // Big Data: Covid, <-- Project
          // d,  <-- Project
          // No  <-- Project
          // > sdfa, <-- Student
          // > Year 9,  <-- Student
          // > sdfa, <-- Student
          // > Year 9,  <-- Student
          // > sdfa, <-- Student
          // > Year 9,  <-- Student
          // ----------- 
          // Big Data: ATLAS, 
          // dfasdsa, 
          // Yes 
          // --
          // sdfa, <-- Student
          // Year 9,  <-- Student
          // --
          // sdfa, <-- Student
          // Year 9,  <-- Student
          // --
          // sdfa, <-- Student
          // Year 9,  <-- Student

          // Add Value to Array
          if (b.tagName !== "UL" && !b.classList.contains("buildStudent")) {
            window.state.datapiGroupList[z][x] = b.value;
            collect += b.value;
          }

          // Add Value to Array
          if (b.tagName === "UL") {
            let getValue = b.querySelector("input[type=radio]:checked");

            if (getValue) {
              window.state.datapiGroupList[z][x] = getValue.dataset.value;
              collect +=
               getValue.dataset.value + " \n";
            }
          }

          if (x < 2) {
            collect += " \n";
          }
        });

        a.querySelectorAll(".studentContainer").forEach((c, y) => {
          c.querySelectorAll("input").forEach((d, w) => {
            collect +=  '> ' + d.value + "\n";
          });

          c.querySelectorAll("select").forEach((d, w) => {
            collect +=  '' + d.value + " \n -- \n";
          });
        });

        collect += "\n ----------- \n \r";
      });

      lib.qs(".frm_section2_submit textarea").value = collect;
    };

    // Re-Render on Submit
    lib
      .qs('.gform_footer input[type="submit"]')
      .addEventListener("click", (e) => {
        e.target.style.pointerEvents = "none";
        dataCollection();
        setTimeout(() => {
          frm_section2.render(); // Re-render form once clicked
        }, 11000);
      });

    let proji = -1;
    let studenti = -1;

    // PERSON Fields
    let projectFields = `
      <div>Project details</div>
      <div class="remove">x</div>
      <div class="gfield_contains_required">
        <select type="text" data-name="project-name" class="dataPiField">
          <option value="Project">Choose your project</option>
          <option value="Big Data: ATLAS">Big Data: ATLAS</option>
          <option value="Big Data: Covid">Big Data: Covid</option>
          <option value="Original Research">Original Research</option>
          <option value="Carbon Researchers">Carbon Researchers</option>
          <option value="Cosmic Mining">Cosmic Mining</option>
          <option value="DNA Origami">DNA Origami</option>
          <option value="Earth Observation">Earth Observation</option>
          <option value="Greener Fragrances">Greener Fragrances</option>
          <option value="Ionic Liquids">Ionic Liquids</option>
          <option value="Ionic Liquids">Treezilla</option>
          <option value="Future Flight">Future Flight</option>
        </select>
      </div>
      <p>Please note only five students per poster</p>
      <input type="text" data-name="research-poster-title" placeholder="Research / poster title" class="dataPiField" style="margin-bottom: 40px"/>
      <p>In addition to producing a poster, does this group express an interest in presenting their research to the whole conference?</p>
      `;

    const studentFields = (i) => {
      studenti++;

      return `<div class="studentContainer">
        <div class="stu-remove">x</div>
        <input type="text" data-name="student-name" placeholder="Student names" class="subPiField"/>
        <div class="gfield_contains_required">
          <select type="text" data-name="year-group" class="subPiField">
            <option value="Null">Year group</option>
            <option value="Year 7">Year 7</option>
            <option value="Year 8">Year 8</option>
            <option value="Year 9">Year 9</option>
            <option value="Year 10">Year 10</option>
            <option value="Year 11">Year 11</option>
            <option value="Year 12">Year 12</option>
            <option value="Year 13">Year 13</option>
            <option value="Year 14">Year 14</option>
            <option value="S1">S1</option>
            <option value="S2">S2</option>
            <option value="S3">S3</option>
            <option value="S4">S4</option>
            <option value="S5">S5</option>
            <option value="S6">S6</option>
          </select>
        </div>
      </div>
    </div>`;
    };

    // Create a NEW PERSON
    createGroup.addEventListener("click", (e) => {
      e.preventDefault();
      buildGroup();
    });

    const buildStudent = (proji) => {
      let randomInt = getRandomInt(999999999);
      let el = _$.create(studentFields(randomInt), `#buildStudent-${proji}`, uniqueID());

      el.querySelector(".stu-remove").addEventListener("click", (e) => {
        // Remove Element
        el.remove();

        // Remove Item from Array
        window.state.datapiGroupList[proji][3].splice(el.dataset.index, 1);
      });

      return el;
    };

    const buildGroup = () => {
      proji++;

      let el = _$.create(
        `<div class="pi_group" data-index="${proji}">
        <div class="projectContainer">
          ${projectFields}
          <ul class="gfield_radio dataPiField">
            <li class="">
              <input id="pi-yes-${proji}" name="project-interest-${proji}" type="radio" data-value="Yes">
              <label for="pi-yes-${proji}">Yes</label>
            </li>
            <li class="">
              <input id="pi-no-${proji}" name="project-interest-${proji}" type="radio" data-value="No">
              <label for="pi-no-${proji}" >No</label>
            </li>
          </ul>
          </div>
          <p class="pi_subtitle">Student details</p>
          <div id="buildStudent-${proji}" class="buildStudent" data-value="${proji}"></div>
          <button class="addStudent frm--input" data-value="${proji}">Add Student</button>`,
        lib.id('project_group'),
        uniqueID()
      );

      // buildStudent();

      el.querySelector(".addStudent").addEventListener("click", (e) => {
        e.preventDefault();

        console.error(lib.qsa('.studentContainer', el).length);

        if(lib.qsa('.studentContainer', el).length > 3) {
          el.querySelector('.addStudent').style.display = "none";
        }

        buildStudent(el.dataset.index);
      });
      

      window.state.piList.push(el);

      el.querySelector(".remove").addEventListener("click", (e) => {
        el.remove();

        // Remove Item from Array
        window.state.datapiGroupList.splice(el.dataset.index, 1);
      });
    };

    // Dont add Fields if datapiGroupList exists
    if (!window.state.datapiGroupList) {
      buildGroup();
    }

    // Create new fields from datapiGroupList]
    if (window.state.datapiGroupList) {
      window.state.datapiGroupList.forEach(() => {
        buildGroup();
      });

      // Load in New Field Data based on Array
      window.state.datapiGroupList.forEach((items, a) => {
        items.forEach((item, b) => {
          let z = lib.qsa(".pi_group")[a].querySelectorAll(".dataPiField")[b];

          if (!z) {
            return;
          }

          if (z.tagName !== "UL") {
            z.value = item;
          }

          if (z.tagName === "UL") {
            // Query Select Z
            z.querySelectorAll("input").forEach((y, c) => {
              if (item === "Yes") {
                z.querySelectorAll("input")[0].checked = true;
              } else {
                z.querySelectorAll("input")[1].checked = true;
              }
            });
          }
        });
      });

      window.state.datapiGroupList.forEach((items, a) => {
        if (!items[3]) {
          return;
        }
        items[3].forEach((subitem, b) => {
          // Select 3rd Array
          //studenti++; // Increment on Generation

          let el = buildStudent(a);

          el.querySelectorAll(".subPiField").forEach((item, c) => {
            if (item.tagName !== "UL") {
              item.value = subitem[c];
            }
            

            if (item.tagName === "UL") {
              // Query Select Z
              item.querySelectorAll("input").forEach((y, c) => {
                if (subitem[c] === "Yes") {
                  item.querySelectorAll("input")[0].checked = true;
                } else {
                  item.querySelectorAll("input")[1].checked = true;
                }
              });
            }
          });
        });
      });
    }
  },
};

export { frm_section2 as default };
